const BASE_URL = 'ai-service/api/nlp-models'

function _getNlpModelsRequest() {
  return {
    url: BASE_URL,
    method: 'get',
  }
}

const nlpModelsRequests = {
  getNlpModelsRequest: (data) => _getNlpModelsRequest(data),
  addNlpModelRequest: (data) => ({
    url: BASE_URL,
    method: 'post',
    data,
  }),
  updateNlpModelRequest: (data) => ({
    url: BASE_URL,
    method: 'put',
    data,
  }),
  deleteNlpModelRequest: ({ nlpModelId }) => ({
    url: `${BASE_URL}/${nlpModelId}`,
    method: 'delete',
  }),
}

export default nlpModelsRequests
